module.exports = __webpack_public_path__ + "img/control_de_calidad_16-9_2880.cf215e57.jpg";